import { createSelector } from '@reduxjs/toolkit';
import { AppState, toAPI } from '../modules';

export const selectRolesAndPrivileges = createSelector(
  (state: AppState) => state.roles,
  (rolesState) => toAPI(rolesState),
);

export const selectRoles = createSelector(
  (state: AppState) => state.roles,
  ({ roles }) => roles,
);

export const selectPrivileges = createSelector(
  (state: AppState) => state.roles,
  ({ privileges }) => privileges,
);

export const selectGuestPrivilege = createSelector(
  (state: AppState) => state.roles,
  ({ privileges }) =>
    Object.values(privileges).find(({ privilege }) => privilege === 'guest'),
);

export const selectRolesFlags = createSelector(
  (state: AppState) => state.roles,
  ({ flags }) => flags,
);

export const selectSelectedTab = createSelector(
  (state: AppState) => state.roles,
  ({ selectedTab }) => selectedTab,
);

export const selectForceLogin = createSelector(
  (state: AppState) => state.roles,
  ({ forceLogin }) => forceLogin,
);

export const selectRolesDate = createSelector(
  (state: AppState) => state.roles,
  ({ date }) => date,
);
